import { useUser } from "@/libs/hooks/use-user";
import Loader from "@quest/ui/components/loader";
import { Navigate, Outlet } from "react-router-dom";

function AuthLayout() {
  const { data: user, isLoading } = useUser();

  if (user) {
    return <Navigate to="/" replace />;
  }

  if (isLoading) {
    return <Loader />;
  }

  return <Outlet />;
}

export default AuthLayout;
